import { HStack, Image, Text, useMediaQuery, VStack } from "@chakra-ui/react";
import appIcon from "../../assets/app_icon.png";
import { useEffect } from "react";
import SignInLayout from "./signin";
import { Outlet } from "react-router";

function AuthLayout() {
  const [isMobile] = useMediaQuery("(max-width: 600px)");

  return (
    <VStack
      h="full"
      w="100%"
      borderRadius={"md"}
      align={"center"}
      justify={"center"}
      p="5"
      transition={"all 300ms"}
      overflow={"scroll"}
    >
      <VStack spacing={"4"} align={"flex-start"} w="100%" maxW="400px">
        <HStack>
          <Image src={appIcon} h="40px" />
          <Text fontSize={'2xl'} fontWeight={'semibold'}>Tarara.app</Text>
        </HStack>
        <VStack
          transition={"all 200ms"}
          bg="#212123"
          borderRadius={"md"}
          align={"flex-start"}
          p="5"
          w="full"
          spacing={"4"}
          minH="200px"
          overflow={"scroll"}
          id="auth_layout_container"
        >
          <Outlet />
        </VStack>
      </VStack>
    </VStack>
  );
}
export default AuthLayout;
